import { newSize, Size } from '@lessonup/pins-shared';

export function getImageSizeFromSource(imgUrl: string): Promise<Size> {
  return resolveOnImageLoad(imgUrl, (img) => newSize(img.width, img.height));
}

export function loadImage(imgUrl: string): Promise<void> {
  return resolveOnImageLoad(imgUrl, () => {});
}

function resolveOnImageLoad<T>(imgUrl: string, callback: (img: HTMLImageElement) => T): Promise<T> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = function () {
      resolve(callback(img));
    };
    img.src = imgUrl;
  });
}
